import { call, put, select, takeLatest } from "redux-saga/effects";
import { saveAssumptions as saveAssumptionsApi } from "../../../services/coilConfiguratorApi";
import type { RootState } from "../../appState";
import { saveAssumptionsSuccess, showToast } from "../actions";
import {
  SAVE_APPLICATION_STATE_SUCCESS,
  SAVE_ASSUMPTIONS,
  SAVE_ASSUMPTIONS_FAILURE,
} from "../types";

function* saveAssumptionsSaga(): Generator {
  try {
    const assumptions = (yield select((state: RootState) => state.coilConfigurator.assumptions.active)) as RootState["coilConfigurator"]["assumptions"]["active"];
    if (!assumptions) {
      throw new Error("Recommendation assumptions are not loaded yet.");
    }
    yield call(saveAssumptionsApi, assumptions);
    const updatedAt = new Date().toISOString();
    yield put(saveAssumptionsSuccess(assumptions));
    yield put({ type: SAVE_APPLICATION_STATE_SUCCESS, updatedAt });
    yield put(showToast("Assumptions saved successfully."));
  } catch (error) {
    const message = error instanceof Error ? error.message : "Failed to save assumptions";
    yield put({ type: SAVE_ASSUMPTIONS_FAILURE, error: message });
    yield put(showToast(message, "error"));
  }
}

function* assumptionsWatcher(): Generator {
  yield takeLatest(SAVE_ASSUMPTIONS, saveAssumptionsSaga);
}

export default assumptionsWatcher;
